import React, { useState, useEffect } from "react";
import { Container, Col, Row, Button, Accordion, Form, Image, Modal } from "react-bootstrap";
import { useNavigate, NavLink } from "react-router-dom";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { apiUrl } from "../commons/inFormTypes";
import { ProfileUrl } from "../commons/IPAddress";
import { IPUrl } from "../commons/IPAddress";
import logo1 from '../assets/img/alert8.png'

function Orders() {
  const [Stchange, setstchange] = useState(false);
  const [orderTypeId, setorderTypeId] = useState(0);
  const [seenFile, setSeenFile] = useState([]);
  const [listOredr, setListOredr] = useState([]);
  const userToken = localStorage.getItem("user_token");
  const navigate = useNavigate()

  // const handleClose = () => setShow(false);
  // const handleShow = () => setShow(true);

  useEffect(() => {
    if (userToken == null) {
      navigate("/");
    } else {
      const axios = require("axios");
      axios
        .post(apiUrl + "Get_StationOrders", {
          code: orderTypeId,
          TokenId: userToken,
          Code_Meli: ""
        })

        .then((res) => {
          if (res.data.result === "true") {
            setSeenFile(res.data.data);
          } else {
          }
        })
        .catch(function (error) {
          if (error.response) {
            toast.error(error.response.data.message, {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
        });
    }
  }, [orderTypeId, Stchange]);


  const detailHandler = (index, val) => {
    console.log(val)
    const axios = require("axios");
    axios
      .post(apiUrl + "Get_DetailsOrders", {
        code: val,
        TokenId: userToken,
        Code_Meli: "fddf"
      })

      .then((res) => {
        console.log("result" + res.data.result)
        if (res.data.result === "true") {

          console.log(res.data.data)
          setListOredr(res.data.data);
        } else {
        }
      })
      .catch(function (error) {
        if (error.response) {
          toast.error(error.response.data.message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      });
  }

  const deleteHandler = (val) => {
    // setShow(false);
    console.log(val)
    console.log(userToken)
    const axios = require("axios");
    axios
      .post(apiUrl + "DeleteOrders", {
        code: val,
        TokenId: userToken,
        Code_Meli: "hjjhgh"
      })

      .then((res) => {
        if (res.data.result === "true") {
          if (Stchange) {
            setstchange(false)
          } else {
            setstchange(true)
          }
          toast.success(res.data.message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          })
        } else {
          toast.error(res.data.message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          })
        }
      })
      .catch(function (error) {
        if (error.response) {
          toast.error(error.response.data.message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      });
  }


  return (
    <div>
      <Container>
        <Row className="justify-content-center">
          <Col xs={12} lg={10}>
            <Row className="justify-content-center gx-1 gx-md-5 gy-3">
              <Col xs={6}>
                <div className="d-flex rgc-title">
                  <div className="rgc-title-point"></div>
                  <h4>سفارشات <span>تمامی</span></h4>
                </div>
              </Col>

              <Col xs={6} md={3} className="text-start me-auto pt-2">
                <Form.Select
                  aria-label="Default select example"
                  className="rgc-select"
                  value={orderTypeId}
                  onChange={(e) => setorderTypeId(e.target.value)}
                >
                  <option value="0">همه</option>
                  {/* <option value="1">در انتظار  پذیرش</option>
                  <option value="2">پذیرش شده</option> */}
                  <option value="3">اتمام یافته</option>
                  <option value="4">لغو شده</option>
                  <option value="4">دارای اعتراض</option>
                </Form.Select>
              </Col>


              <Col xs={12} >
                <Accordion defaultActiveKey="0" flush >
                  {seenFile.length === 0 ?
                    <Col xs={12} className="rgc-orderreg-items rgc-score-body text-center" >
                      <span>سفارش موجود نیست</span>
                    </Col>
                    :
                    seenFile.map((data, index) => {
                      return (
                        <Accordion.Item className="rgc-driver-card"
                          key={index}
                          eventKey={index} onClick={() => detailHandler(index, data.Order_Id)}>
                          <Accordion.Header>
                            <Row className="juustify-content-start rgc-driver-info w-100 g-0">
                              <Col xs={5} md={6} className="rgc-driver-image text-end text-md-center mt-2" >

                                {data.img_Users == null ?
                                  <i className="fa fa-user-circle  rgc-avatar-icon" aria-hidden="true"></i>
                                  :
                                  <Image src={ProfileUrl + data.img_Users} className="rgc-avatar-driver" />
                                }
                              </Col>

                              <Col xs={7} md={6} className="text-end mt-2">
                                <div className="rgc-driver-btn rgc-orders-btn-edit"
                                  style={{ color: data.Color, background: data.Backcolor }} >
                                  <i class="fas fa-hourglass px-1"></i>
                                  {data.Stage_Tittle}
                                </div>
                              </Col>

                              <Col xs={12} md={6} className="rgc-driver-txt text-end text-md-center">
                                <div className="d-flex flex-column">
                                  <div>
                                    <span> نام: </span>
                                    <span>{data.Name}</span>
                                  </div>
                                </div>
                              </Col>
                              <Col xs={12} md={6} className="rgc-driver-txt text-end">
                                <div className="d-flex flex-column">
                                  <div>
                                    <span>شماره تماس:</span>
                                    <span>{data.Mobile_User}</span>
                                  </div>
                                </div>
                              </Col>

                              <Col xs={12} className="rgc-weight py-2 text-center">
                                <div className="d-flex justify-content-center rgc-contact">
                                  <a href={`tel:${data.Mobile_User}`}>
                                    <i className="fa fa-phone"></i>
                                  </a>
                                  <i class='fas fa-comments'></i>
                                  <i class="fa fa-map-marker-alt"></i>
                                </div>

                              </Col>

                              <Col xs={12} className="rgc-driver-txt text-start">
                              <div className="d-flex justify-content-end">
                                      <div className="rgc-driver-txt-items">
                                    <span>وزن کل:</span>
                                    <span>{data.Weight}</span>
                                  </div>

                                  <div>
                                    <span> مبلغ کل:</span>
                                    <span>{Intl.NumberFormat('en-US').format(parseFloat(data.Coint))}</span>
                                  </div>

                                </div>
                              </Col>

                            </Row>
                          </Accordion.Header>
                          <Accordion.Body >
                            <hr />
                            <Row className="justify-content-start rgc-driver-content">
                              {listOredr.map((data, index) => {
                                return (
                                  <Col xs={12} lg={6} key={index} className="gx-md-5 gy-3">
                                    <Row className="rgc-driver-item g-0">
                                      <Col xs={2} className="text-center">
                                        <Image src={IPUrl + data.Icon} alt="" className="rgc-image" />
                                      </Col>

                                      <Col xs={10} className="text-end">
                                        <span>{data.Type_Trash_Tittle}</span>
                                      </Col>
                              
                                      <Col xs={6} className="text-center">
                                        <span>{data.Sub_Weight}</span><span>{data.Type_Weight_Title}</span>
                                      </Col>

                                      <Col xs={6} className="text-center">
                                        <span>{Intl.NumberFormat('en-US').format(data.Sub_Coint)}</span><span>&nbsp;ریال </span>
                                      </Col>
                                    </Row>
                                  </Col>
                                )
                              })}
                              <div className="w-100"></div>


                            </Row>
                          </Accordion.Body>
                        </Accordion.Item>
                      )
                    })}
                </Accordion>
              </Col>

            </Row>
          </Col>
        </Row>


      </Container>
    </div>
  )
}

export default Orders